import { render, staticRenderFns } from "./ProjectClientRow.vue?vue&type=template&id=46c1678f&scoped=true"
import script from "./ProjectClientRow.vue?vue&type=script&lang=ts"
export * from "./ProjectClientRow.vue?vue&type=script&lang=ts"
import style0 from "./ProjectClientRow.vue?vue&type=style&index=0&id=46c1678f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c1678f",
  null
  
)

export default component.exports